var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistogram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    rx: 56,
    fill: "#FFEEDE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_4448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3219 88H27.1657C25.4174 88 24 86.5826 24 84.8343V52.0892C24 50.3408 25.4174 48.9234 27.1657 48.9234H32.3219C34.0703 48.9234 35.4877 50.3408 35.4877 52.0892V84.8343C35.4877 86.5826 34.0704 88 32.3219 88Z",
    fill: "#FEA54D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.826 88H44.6698C42.9214 88 41.504 86.5826 41.504 84.8342V67.2655C41.504 65.5172 42.9214 64.0998 44.6698 64.0998H49.826C51.5743 64.0998 52.9917 65.5172 52.9917 67.2655V84.8342C52.9917 86.5826 51.5744 88 49.826 88Z",
    fill: "#FFBF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3302 88H62.174C60.4257 88 59.0083 86.5826 59.0083 84.8343V55.8519C59.0083 54.1036 60.4257 52.6862 62.174 52.6862H67.3302C69.0786 52.6862 70.496 54.1036 70.496 55.8519V84.8343C70.496 86.5826 69.0786 88 67.3302 88Z",
    fill: "#EB731A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8343 88H79.6781C77.9297 88 76.5123 86.5826 76.5123 84.8343V43.3093C76.5123 41.561 77.9297 40.1436 79.6781 40.1436H84.8343C86.5826 40.1436 88 41.561 88 43.3093V84.8343C88 86.5826 86.5826 88 84.8343 88Z",
    fill: "#FEB163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2802 56.0291C47.0291 56.0291 46.7783 55.9319 46.589 55.7379L29.7322 38.4686C29.3596 38.0869 29.367 37.4755 29.7487 37.1029C30.1305 36.7302 30.7419 36.7377 31.1145 37.1193L47.9712 54.3885C48.548 54.9795 48.1152 56.0291 47.2802 56.0291Z",
    fill: "#A0A4A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5319 55.0342C47.6505 55.0342 47.2334 53.8723 47.9262 53.3155L61.7339 42.2194L79.3469 28.0701C80.3182 27.29 81.5279 28.7959 80.5567 29.576L62.9437 43.7253L49.1362 54.8212C48.9578 54.9646 48.7441 55.0342 48.5319 55.0342Z",
    fill: "#A0A4A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7439 40.0188C31.3881 40.0188 32.7209 38.6883 32.7209 37.047C32.7209 35.4057 31.3881 34.0752 29.7439 34.0752C28.0998 34.0752 26.767 35.4057 26.767 37.047C26.767 38.6883 28.0998 40.0188 29.7439 40.0188Z",
    fill: "#425B72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.248 58.0672C48.8921 58.0672 50.2249 56.7367 50.2249 55.0954C50.2249 53.4541 48.8921 52.1236 47.248 52.1236C45.6038 52.1236 44.271 53.4541 44.271 55.0954C44.271 56.7367 45.6038 58.0672 47.248 58.0672Z",
    fill: "#425B72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7521 44.0774C66.3962 44.0774 67.7291 42.7469 67.7291 41.1056C67.7291 39.4643 66.3962 38.1338 64.7521 38.1338C63.108 38.1338 61.7751 39.4643 61.7751 41.1056C61.7751 42.7469 63.108 44.0774 64.7521 44.0774Z",
    fill: "#425B72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2561 29.9436C83.9003 29.9436 85.2331 28.6131 85.2331 26.9718C85.2331 25.3305 83.9003 24 82.2561 24C80.612 24 79.2792 25.3305 79.2792 26.9718C79.2792 28.6131 80.612 29.9436 82.2561 29.9436Z",
    fill: "#425B72"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_4448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(24 24)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistogram);
export default __webpack_public_path__ + "static/media/histogram.053e6a1a042c17af509383b0de763966.svg";
export { ForwardRef as ReactComponent };